import { lazy } from "react";
import Loadable from "components/Loadable";

// Define lazy-loaded components
const AuditList = Loadable(lazy(() => import("../AuditList")));
const AuditDetail = Loadable(lazy(() => import("../AuditDetail")));

// Helper function to create routes
const AudtiTrail = Loadable(lazy(() => import("../AuditTrail")));
const DetailsHistory = Loadable(lazy(() => import("../DetailsHistory")));
const UserList = Loadable(lazy(() => import("../UserList")));

const AuditRoutes = [
  {
    path: "audit-trail",
    children: [
      { path: "list/:userId", element: <AuditList /> },
      { path: "list/:userId/:designationId", element: <AuditList /> },
      { path: ":id", element: <AuditDetail /> },
      { path: "trail", element: <AudtiTrail /> },
      { path: "details-history", element: <DetailsHistory /> },
      { path: "user-list", element: <UserList /> },
      // { path: "details-view", element: <DetailsView /> },
    ],
  },
];

export default AuditRoutes;
